import { ACCOUNT_DETAIL_RESPONSE, DELETE_ACCOUNT_RESPONSE } from './actions'

const initialState = {
  accounts: [],
}

export default function accounts(state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_DETAIL_RESPONSE:
      return [...action.payload]

    case DELETE_ACCOUNT_RESPONSE: {
      return {
        ...state,
        accounts: state.accounts.filter(
          (currentAccount) =>
            parseInt(currentAccount.id, 10) !== action.payload.id
        ),
      }
    }
    default:
      return state
  }
}
